import { useState, useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";

const RouteAnnouncer = () => {
  const location = useLocation();
  const [announcement, setAnnouncement] = useState("");
  const isMountRef = useRef(true);

  useEffect(() => {
    // On first mount (full page reload via window.location.href) the screen
    // reader hasn't registered the live region yet — use a longer delay.
    // On subsequent React Router navigations (history.push) the component
    // stays mounted so a short delay is enough.
    const delay = isMountRef.current ? 500 : 150;
    isMountRef.current = false;

    setAnnouncement("");

    const timer = setTimeout(() => {
      const mainContent = document.getElementById("main-content");
      const heading = mainContent
        ? mainContent.querySelector("h1, h2")
        : null;
      const text = heading
        ? heading.textContent
        : document.title;
      setAnnouncement(`Navigated to ${text}`);
    }, delay);

    return () => clearTimeout(timer);
  }, [location.pathname]);

  useEffect(() => {
    if (announcement) {
      const clearTimer = setTimeout(() => setAnnouncement(""), 1000);
      return () => clearTimeout(clearTimer);
    }
  }, [announcement]);

  return (
    // role="status" implies aria-live="polite" — these must match.
    // "polite" is correct for navigation announcements: it waits for the
    // screen reader to finish speaking before interrupting, which is less
    // jarring than "assertive" and is the standard pattern for route changes.
    <span
      role="status"
      aria-live="polite"
      aria-atomic="true"
      style={{
        position: "absolute",
        width: "1px",
        height: "1px",
        overflow: "hidden",
        clip: "rect(0,0,0,0)",
        whiteSpace: "nowrap",
        border: 0,
      }}
    >
      {announcement}
    </span>
  );
};

export default RouteAnnouncer;